import {Component, OnInit} from '@angular/core';
import {PortfolioService} from '../shared/profile/portfolio.service'
import {HttpClient} from '@angular/common/http';

import {Subject} from 'rxjs/Subject';
import {debounceTime} from 'rxjs/operator/debounceTime';

import {Router} from '@angular/router';
import {TrackingServiceService} from '../shared/service/tracking-service.service';
import {LinenotificationService} from '../shared/service/linenotification.service'


import {validate} from 'validate.js';
import {environment} from '../../environments/environment';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
    profile: any = {};
    portfolio: any = {};
    error: any = {};
    form = {
        name: null,
        email: null,
        message: null
    };
    private _success = new Subject<string>();
    successMessage: string;
    typeAlert: string;

    constructor(private port: PortfolioService, private http: HttpClient,
                private router: Router, private track: TrackingServiceService, private lineNoti: LinenotificationService) {
    }

    ngOnInit() {
        this.profile = this.port.getProfile();
        this.portfolio = this.port.getPortfolio();

        this.typeAlert = 'success';
        this._success.subscribe((message) => this.successMessage = message);
        debounceTime.call(this._success, 3000).subscribe(() => this.successMessage = null);

        this.track.eventTracking('visit', 'visit', 'user visited your web site');
    }

    validateInput(data) {
        const validateRules = {
            name: {
                presence: {message: '^Please enter name'},
            },
            email: {
                presence: {message: '^Please enter email'},
                email: {message: '^Email is invalid'},
            },
            message: {
                presence: {message: '^Please enter message'},
            },
        };

        const error = validate(
            {
                name: data.name ? data.name.replace(' ', '') : null,
                email: data.email,
                message: data.message ? data.message.replace(' ', '') : null,
            }
            , validateRules);

        if (error) {
            return error;
        } else {
            return false;
        }
    }

    sendMessage() {
        const errorMessage = this.validateInput(this.form);
        if (errorMessage) {
            this.error = errorMessage
        } else {
            const formData = new FormData();
            formData.append('name', this.form.name);
            formData.append('from', this.form.email);
            formData.append('message', this.form.message);

            this.http.post(environment.MAIL_API, formData)
                .subscribe(
                    res => {
                        this.form = {
                            name: null,
                            email: null,
                            message: null
                        };
                        this._success.next(`Send email successfully !`);
                        this.track.eventTracking('send mail', 'email', 'send email successfully');
                    },
                    err => {
                        console.log('Error occurred');
                    }
                );
        }
        this.track.eventTracking('click send mail', 'email', 'send email');
    }

    open(data) {
        this.track.eventTracking('click portfolio card', 'portfolio', data.name);
    }


}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts